module.exports = "<div class=\"error_wrap_box\">\n  <div class=\"show\">\n    <h1>Page not found !</h1>\n    <p class=\"info\">Sorry , we can't find the page you are looking for.<br/>Check the button to come back home page.</p>\n    <el-button type=\"danger\" size=\"mini\" round @click=\"backToPrv\">GO BACK</el-button>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/error/error.tpl
// module id = SnSd
// module chunks = 1